import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'share-empty-state',
  templateUrl: './share-empty-state.component.html'
})
export class ShareEmptyStateComponent {
  @Input() icon = 'pi pi-inbox';
  @Input() heading = 'No items found';
  @Input() message = 'Try adjusting your search or filter criteria.';
  @Input() actionLabel = '';
  @Output() action = new EventEmitter<void>();
}
